import { useMutation } from "react-query";

import { WorkOrderReportIProps } from "~/entity/Ivideon/model/schema";
import { useNotify } from "~/shared/hooks/useNotify";

import { useIvideon } from "./useIvideon";

export const useGetWorkOrderReport = (closeModal: () => void) => {
  const { getWorkOrderReport } = useIvideon();
  const { notifyReport } = useNotify();

  const { data, isLoading, isError, mutate } = useMutation({
    mutationFn: (data: WorkOrderReportIProps) => getWorkOrderReport(data),
    onSuccess: (response) => {
      const hash = response?.data?.fileHash;
      if (hash) {
        notifyReport(hash);
        closeModal();
      }
    },
  });

  return {
    data: data?.data,
    isLoading: isLoading,
    isError: isError,
    getDataReport: mutate,
  };
};
